import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useEffect, useState } from "react";
import { Box, Button, Tabs, Tab } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from '@mui/icons-material/Download';
import HostPayoutList from "../../features/manageHostPayout/payoutList";
import { useLazyGetPayoutQuery, useUpdatePayoutMutation } from "../../services/payout";
import { showError } from "../../constants/toasts";
import { isValidInput } from "../../utils/validations";

const ManageHostPayout = () => {

  const navigate = useNavigate();
  const [getPayout] = useLazyGetPayoutQuery()
  const [updatePayout] = useUpdatePayoutMutation()
  const [payoutData, setPayoutData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [status, setStatus] = useState<"PENDING" | "APPROVED" | "REJECTED">("PENDING");

  const fetchHostPayout = async () => {
    try {
      const response = await getPayout({
        from: page,
        size: pageSize,
        search: debouncedSearchTerm,
        status,
      }).unwrap();

      if (response?.statusCode === 200) {
        setPayoutData(response.data.data || []);
        setTotalCount(response.data.total || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch host Payout");
    }
  };
  const handleUpdateStatus = async (id: string, status: "APPROVED" | "REJECTED") => {
    try {
      const res = await updatePayout({ id, body: { status } }).unwrap();
      if (res?.statusCode === 200) {
        await fetchHostPayout();
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to update payout status");
    }
  }
  useEffect(() => {
    fetchHostPayout()
  }, [page, debouncedSearchTerm, status])
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Host Payout</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Host Payout
        </p>
      </div>

      {/* <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/dashboard/unregistered-users")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$2000</h2>
          <p>Total requested Payout By Host</p>
        </div>
      </div> */}

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_grey"><DownloadIcon /> Export</Button>
          </div>
        </div>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
          <Tabs
            value={status}
            onChange={(_, val) => setStatus(val)}
            aria-label="payout status tabs"
          >
            <Tab label="Pending" value="PENDING" />
            <Tab label="Approved" value="APPROVED" />
            <Tab label="Rejected" value="REJECTED" />
          </Tabs>
        </Box>
        <HostPayoutList data={payoutData} onUpdateStatus={handleUpdateStatus} showActions={status === "PENDING"} />
      </div>
    </MainContainer>
  );
};

export default ManageHostPayout;
